import { forwardRef } from 'react';

import {
  DefaultComponentProps,
  ElementSize,
  RenderPropFC,
} from '../../../../types';
import { renderFCRenderProp } from '../../../../utils';
import { cn } from '../../../../utils/styles';
import { InputClassNames } from '../../constants';

import {
  InputMainWrapperRoot,
  InputMainWrapperSideArea,
} from './InputMainWrapper.styled';

export interface InputMainWrapperProps
  extends React.HTMLAttributes<HTMLDivElement>,
    DefaultComponentProps {
  elementSize: ElementSize;
  hasError: boolean | undefined;
  disabled: boolean;
  hasNoDisabledStyle?: boolean;
  leading?: RenderPropFC;
  trailing?: RenderPropFC;
}

const InputMainWrapper = forwardRef<HTMLDivElement, InputMainWrapperProps>(
  (props, rootRef) => {
    const {
      className,
      elementSize,
      hasError = false,
      leading,
      hasNoDisabledStyle,
      trailing,
      disabled,
      children,
      ...rest
    } = props;

    return (
      <InputMainWrapperRoot
        $hasError={hasError}
        $hasNoDisabledStyle={hasNoDisabledStyle}
        $isDisabled={disabled}
        $size={elementSize}
        className={cn(InputClassNames.MainWrapper, className)}
        ref={rootRef}
        {...rest}>
        {leading && (
          <InputMainWrapperSideArea $isDisabled={disabled} $size={elementSize}>
            {renderFCRenderProp(leading, {})}
          </InputMainWrapperSideArea>
        )}
        {children}
        {trailing && (
          <InputMainWrapperSideArea $isDisabled={disabled} $size={elementSize}>
            {renderFCRenderProp(trailing, {})}
          </InputMainWrapperSideArea>
        )}
      </InputMainWrapperRoot>
    );
  },
);

InputMainWrapper.displayName = 'InputMainWrapper';

export default InputMainWrapper;
